// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";
import { firebaseAuth } from "@/shared/integrations/firebase/client";

// Environment variables loaded based on mode:
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Environment detection
const getEnvironmentInfo = () => {
  const url = SUPABASE_URL || '';
  const isLocal = url.includes('127.0.0.1') || url.includes('localhost');
  const isProduction = url.includes('supabase.co') && !url.includes('localhost');
  const projectId = url.match(/https?:\/\/([^.]+)\.supabase\.co/)?.[1] || 
                    url.match(/https?:\/\/127\.0.0\.1:(\d+)/)?.[0] || 
                    'unknown';
  
  let envType = 'unknown';
  if (isLocal) envType = 'local';
  else if (isProduction) envType = 'production';
  else envType = 'development';
  
  return { envType, projectId, url, isLocal, isProduction };
};

const envInfo = getEnvironmentInfo();

// Export environment info utility
export const getSupabaseEnvironment = () => envInfo;

// Import the supabase client like this:
// import { supabase } from "@/shared/integrations/supabase/client";

// Create Supabase client with Firebase Auth integration
// According to Supabase docs: https://supabase.com/docs/guides/auth/third-party/firebase-auth
// The accessToken function should return the Firebase Auth JWT of the current user
if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  throw new Error("Missing Supabase configuration. Please check your environment variables.");
}

// Create Supabase client with Firebase Auth integration
// Following Supabase docs: https://supabase.com/docs/guides/auth/third-party/firebase-auth
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: typeof window !== "undefined" ? localStorage : undefined,
    persistSession: true,
    autoRefreshToken: true,
  },
  accessToken: async () => {
    return (await firebaseAuth.currentUser?.getIdToken(/* forceRefresh */ false)) ?? null;
  },
});

// Export constants for use in other files
export { SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY };
